'use client';

/**
 * SeasonalPriceInfo — badge "(i)" con tooltip che spiega il prezzo stagionale.
 * Usato dove si mostra il prezzo escursione (dettaglio + card catalogo): il prezzo
 * cambia in base al periodo/mese dell'anno; mostriamo quello della prossima data utile.
 */

import { Info } from 'lucide-react';

export default function SeasonalPriceInfo({ className = '' }: { className?: string }) {
  return (
    <span className={`relative inline-flex items-center group ${className}`} data-cid="seasonal-price-info">
      <span className="inline-flex items-center gap-1 text-[11px] text-slate-400 cursor-help">
        Prezzo stagionale <Info size={12} />
      </span>
      <span
        role="tooltip"
        className="pointer-events-none absolute left-0 bottom-full mb-1.5 w-60 rounded-lg bg-slate-900 text-white text-[11px] leading-snug p-2.5 opacity-0 group-hover:opacity-100 transition-opacity z-[60] shadow-xl"
      >
        Il prezzo varia in base al periodo dell&apos;anno (stagione bassa/media/alta).
        Qui è mostrato il prezzo della prossima data disponibile; selezionando una data
        vedrai il prezzo esatto di quel periodo.
      </span>
    </span>
  );
}
